

const dialogShiftScriptUrl =
  "https://assets.dialogshift.com/code/unified-ghotel.js";
const greensignScriptUrl = "https://api.greensign.de/widget/greensign.js";

const hotelCareerScriptUrl = "https://www.hotelcareer.de/js/ajaxjobliste.js";
const hotelCareerIframeUrl =
  "https://jobs.hotelcareer.de/index.php?sei_id=321&pid=522";

const greenSignUrl = "https://www.greensign.de/";

const buchungsBaseLink = "https://reservieren.ghotel.de/?";
const buchungsDefaultLink = `${buchungsBaseLink}configcode=GHOTEL&themecode=GHHDE2&brand=GHHDE&`;

var debug = false;

if (debug) {
  window.Cookiebot = {
    'consent': {
      'necessary': true,
      'preferences': true,
      'marketing': true,
      'statistics': true,
    },
  }
}

window.addEventListener("load", function (event) {
  if (document.querySelector(".mobile_lightbox")) {
    var lightboxNodes = document.querySelectorAll(".mobile_lightbox");
    for (let i = 0; i < lightboxNodes.length; i++) {
      lightboxNodes[i].addEventListener("click", function () {
        if (this.classList.contains("mobile_lightbox_active"))
          this.classList.remove("mobile_lightbox_active");
        else if (!this.classList.contains("mobile_lightbox_active"))
          this.classList.add("mobile_lightbox_active");
      });
    }
  }

  function initModalTrigger() {
    if (document.querySelector(".promobar-entry-modal")) {
      var modalEntries = document.querySelectorAll(".promobar-entry-modal");
      var modalBackground = document.querySelector(
        ".promobar-modal-background"
      );
      modalBackground.addEventListener("click", function (event) {
        for (let j = 0; j < modalEntries.length; j++) {
          if (modalEntries[j].classList.contains("active"))
            modalEntries[j].classList.remove("active");
        }
        if (modalBackground.classList.contains("active"))
          modalBackground.classList.remove("active");
      });

      for (let i = 0; i < modalEntries.length; i++) {
        var dataIndex = modalEntries[i].getAttribute("data-index");
        var modalOrigin = document.querySelector(
          '.promobar-entry[data-index="' + dataIndex + '"'
        );
        modalOrigin.addEventListener("click", function (event) {
          for (let j = 0; j < modalEntries.length; j++) {
            if (modalEntries[j].classList.contains("active"))
              modalEntries[j].classList.remove("active");
          }
          if (!modalEntries[i].classList.contains("active"))
            modalEntries[i].classList.add("active");
          if (!modalBackground.classList.contains("active"))
            modalBackground.classList.add("active");
        });

        modalEntries[i]
          .querySelector(".closeModal")
          .addEventListener("click", function (event) {
            if (modalEntries[i].classList.contains("active"))
              modalEntries[i].classList.remove("active");
            if (modalBackground.classList.contains("active"))
              modalBackground.classList.remove("active");
          });
      }
    }
  }
  initModalTrigger();

  /**
   * Initialises the given promobar node and sets needed triggers and functions
   * @param {node} node main element of the promobar that should be initialised
   * @returns {boolean} true if successful
   */

  function initPromobar() {
    if (document.getElementById("promobar")) {
      var node = document.getElementById("promobar");
      var promobarTimer = node.getAttribute("data-timer");
      if (node.childElementCount > 1) {
        setInterval(function () {
          let currentIndex = parseInt(node.getAttribute("data-index"));
          let maxIndex = node.getAttribute("data-count") - 1;
          let newIndex = 0;
          if (currentIndex < maxIndex) newIndex = currentIndex + 1;
          node
            .querySelector('[data-index="' + currentIndex + '"]')
            .classList.remove("active");
          node
            .querySelector('[data-index="' + newIndex + '"]')
            .classList.add("active");
          node.setAttribute("data-index", newIndex);
        }, promobarTimer);
      }
    }
  }
  initPromobar();
  var filter = "";
  if (document.documentElement.getAttribute("lang") == "en-GB") {
    filter = {
      Location: {
        "Bochum": {},
        "Essen": {},
        "Göttingen": {},
        "Hanover": {},
        "Kiel": {},
        "Koblenz": {},
        "Ludwigsburg": {},
        "Neckarsulm": {},
        "Würzburg": {},
      },
      Brand: {
        "GHOTEL hotel & living": {},
        "nestor Hotel": {},
      },
    };
  } else {
    filter = {
      Standort: {
        "Bochum": {},
        "Essen": {},
        "Göttingen": {},
        "Hannover": {},
        "Kiel": {},
        "Koblenz": {},
        "Ludwigsburg": {},
        "Neckarsulm": {},
        "Würzburg": {},
      },
      Marke: {
        "GHOTEL hotel & living": {},
        "nestor Hotel": {},
      },
    };
  }

  window.filter = filter;

  function getInputs(inputs, formId) {
    var inputNodes = [];
    for (var j = 0; j < inputs.length; j++) {
      var checkboxes = document.getElementById(
        "input_" + formId + "_" + inputs[j].innerHTML
      ).childNodes;
      inputNodes = inputNodes.concat(Array.from(checkboxes));
      inputNodes.forEach((node) => {
        node.querySelector("input").setAttribute("autocomplete", "off");
      });
    }
    return inputNodes;
  }
  window.getInputs = getInputs;

  function populateInputList(choiceArray) {
    var index = 0;
    var hotelList = {};
    for (var i = 0; i < choiceArray.length; i++) {
      if (choiceArray[i].nodeType == 1) {
        let id = choiceArray[i].querySelector("input").getAttribute("id");
        let value = choiceArray[i].querySelector("input").getAttribute("value");
        if (!id.includes("select_all")) {
          hotelList[index] = {
            id: id,
            value: value,
          };
          index++;
        }
      }
    }
    return hotelList;
  }

  window.populateInputList = populateInputList;

  function populateFilterList(list, filter) {
    for (var i = 0; i < Object.keys(list).length; i++) {
      for (let key of Object.keys(filter)) {
        for (let key2 of Object.keys(filter[key])) {
          if (list[i].value.includes(key2)) {
            let index = Object.keys(filter[key][key2]).length;
            filter[key][key2][index] = {
              id: list[i].id,
              value: list[i].value,
            };
          }
        }
      }
    }
    return filter;
  }
  window.populateFilterList = populateFilterList;

  function createListElement(id, value) {
    let element = document.createElement("li");
    let link = document.createElement("a");
    link.innerHTML = value;
    link.setAttribute("link", id);
    link.setAttribute("onclick", "javascript:clickListElement(this)");
    element.appendChild(link);
    return element;
  }
  window.createListElement = createListElement;

  function clickListElement(node) {
    let id = node.getAttribute("link");
    for (let link of document.querySelectorAll('[link="' + id + '"]')) {
      if (link.classList.contains("active")) link.classList.remove("active");
      else link.classList.add("active");
    }
    document.getElementById(node.getAttribute("link")).click();
  }
  window.clickListElement = clickListElement;

  function showList(node) {
    if (node.classList.contains("open")) node.classList.remove("open");
    else node.classList.add("open");
  }
  window.showList = showList;

  function useFilter(node) {
    var list = node.getAttribute("type");

    for (let elem of document.querySelectorAll(".formListButton")) {
      if (elem == node && !elem.classList.contains("active"))
        elem.classList.add("active");
      else if (elem != node && elem.classList.contains("active"))
        elem.classList.remove("active");
    }

    for (let elem of document.querySelectorAll(".linkList")) {
      if (
        elem.getAttribute("listtype") == list &&
        elem.classList.contains("hidden")
      )
        elem.classList.remove("hidden");
      else if (
        elem.getAttribute("listtype") != list &&
        !elem.classList.contains("hidden")
      )
        elem.classList.add("hidden");
    }
  }
  window.useFilter = useFilter;

  function createLinkList(data) {
    var listContent = document.createElement("div");
    listContent.classList.add("listContent");
    var searchList = document.createElement("div");
    var buttonRow = document.createElement("div");
    buttonRow.classList.add("row", "listButtonRow");
    searchList.classList.add("searchWrapper");
    var typeIndex = 0;
    for (let type of Object.keys(data)) {
      var list = document.createElement("ul");
      list.setAttribute("listType", type);
      list.classList.add("linkList");
      list.classList.add(type);
      var button = document.createElement("a");
      button.classList.add("formListButton");
      button.setAttribute("onclick", "javascript:window.useFilter(this)");
      button.innerHTML = type;
      button.type = type;
      if (typeIndex > 0) list.classList.add("hidden");
      if (typeIndex == 0) button.classList.add("active");
      buttonRow.appendChild(button);
      typeIndex++;
      for (let entry of Object.keys(data[type])) {
        var subList = document.createElement("ul");
        subList.classList.add("subLinkList");
        var label = document.createElement("label");
        label.classList.add("subLinkListLabel");
        label.innerHTML = entry;
        label.setAttribute("onclick", "javascript:showList(this)");
        subList.appendChild(label);

        for (let index of Object.keys(data[type][entry])) {
          var sublistElement = createListElement(
            data[type][entry][index].id,
            data[type][entry][index].value
          );
          subList.appendChild(sublistElement);
        }

        list.appendChild(subList);
      }
      searchList.appendChild(list);
    }
    listContent.appendChild(buttonRow);
    listContent.appendChild(searchList);
    return listContent;
  }

  window.createLinkList = createLinkList;

  function initFormList(placeholder) {
    var fieldAttributes = placeholder.parentElement
      .getAttribute("id")
      .split("_");

    var formId = fieldAttributes[1];

    var choices = getInputs(
      document.querySelectorAll('[type="inputId"]'),
      formId
    );

    placeholder.parentElement.setAttribute("style", "margin-bottom:1rem;");

    window.hotelList = populateInputList(choices);

    if (window.filteredList == undefined)
      window.filteredList = populateFilterList(window.hotelList, filter);
    if (!placeholder.querySelector(".listContent"))
      placeholder.appendChild(createLinkList(window.filteredList));

    var submit = document.querySelector('.gform_button[type="submit"]');
    window.clickHandler = submit.onclick;
    submit.onclick = false;

    submit.addEventListener("click", function (event) {
      let inputs = getInputs(
        document.querySelectorAll('[type="inputId"]'),
        formId
      );
      let count = 0;
      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].querySelector("input").checked) {
          count++;
        }
      }
      if (count == 0) {
        var message = "Bitte wählen Sie mindestens ein Hotel!";
        if (document.documentElement.getAttribute("lang") == "en-GB")
          message = "Please choose at least one hotel!";
        alert(message);
      } else {
        if (document.querySelector(".hotelCheck input"))
          document.querySelector(".hotelCheck input").value = "aa";
        window.clickHandler.call(this, event);
      }
    });
    placeholder.setAttribute("init", "true");
  }

  window.initFormList = initFormList;

  var searchBar = document.querySelector(".form-searchbar");
  if (searchBar) {
    if (
      searchBar.getAttribute("init") == "false" &&
      !document.querySelector(".subLinkList")
    ) {
      initFormList(searchBar);
    }
  }

  function manageBookingFormFields() {
    let value = $('#bookingFormContainer select[name="hotel"]')
      .children("option:selected")
      .val();
    if (checkForFranchise(value) == true) {
      for (
        var i = 0;
        i <
        document.querySelector("form .bookingForm__fields").childElementCount -
        1;
        i++
      ) {
        let child = document.querySelector("form .bookingForm__fields")
          .children[i];
        if (
          child.classList.contains("non_franchise_info") &&
          !child.classList.contains("hidden")
        ) {
          child.classList.add("hidden");
        }
        if (
          child.classList.contains("franchise_info") &&
          child.classList.contains("hidden")
        ) {
          child.classList.remove("hidden");
        }
      }
    } else {
      for (
        var j = 0;
        j <
        document.querySelector("form .bookingForm__fields").childElementCount -
        1;
        j++
      ) {
        let child = document.querySelector("form .bookingForm__fields")
          .children[j];
        if (
          child.classList.contains("non_franchise_info") &&
          child.classList.contains("hidden")
        ) {
          child.classList.remove("hidden");
        }
        if (
          child.classList.contains("franchise_info") &&
          !child.classList.contains("hidden")
        ) {
          child.classList.add("hidden");
        }
      }
    }
  }

  /**
   * hide inputs onchange and onready if the booking engine of the choosen hotel doesnt support them.
   */

  document.ready = function () {
    manageBookingFormFields();
  };
  document.getElementById("location").onchange = function () {
    manageBookingFormFields();
  };

  /**
   * handle the submit and create the request using the given profile
   */

  /*
  Room Parameter Scheme:
  rooms=3&adult=1|2|2&child=3|0|1&childages=1|2|3,,1    
  */
  let today = new Date();
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  window.dataLayer["quickBooking"] = {
    roomCount: document.querySelectorAll(
      ".bookingForm_config--input--list__rooms--roomWrapper"
    ).length,
    language: "en-US",
    coupon: "",
    hotelValue: "default",
    hotelName: "default",
    arrive: `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`,
    depart: `${tomorrow.getFullYear()}-${tomorrow.getMonth() + 1
      }-${tomorrow.getDate()}`,
    hotelChain: 19763,
    level: "Hotel",
    adultsSerialized: "",
    childrenCountSerialized: "",
    childrenAgeSerialized: "",
    nights: Math.ceil(
      ($("#departure").datepicker("getDate") -
        $("#arrival").datepicker("getDate")) /
      (1000 * 60 * 60 * 24)
    ),
    defaultLink:
      buchungsDefaultLink,
    baseLink: buchungsBaseLink,
    gclid: getGclid(),
  };

  function getGclid() {
    let match = /[?]?(gclid)=([\w-]+)/.exec(window.location.href);
    if (match) return `&gclid=${match[match.indexOf("gclid") + 1]}`;
    return "";
  }

  document.getElementById("promocode").addEventListener("change", (event) => {
    window.dataLayer.quickBooking.coupon = event.target.value;
  });

  document
    .getElementById("location")
    .addEventListener("change", function (event) {
      let showMaxChildAge = ["70417", "7167", "70267"];
      let hideMoreThan2 = ["70417", "7167", "70411", "7813", "70418"];
      let hideMoreThan3 = ["7814", "4483", "70412"];
      var currentHotel = event.target.value;

      if (
        showMaxChildAge.includes(currentHotel) &&
        document.getElementById("hideExtraAge") == null
      ) {
        var sheet1 = document.createElement("style");
        sheet1.setAttribute("id", "hideExtraAge");
        sheet1.innerHTML = ".extra-age {display:none!important;}";
        document.getElementById("bookingFormContainer").appendChild(sheet1);
      } else {
        if (
          document.getElementById("hideExtraAge") &&
          !showMaxChildAge.includes(currentHotel)
        ) {
          document.getElementById("hideExtraAge").remove();
        }
      }
      if (
        hideMoreThan2.includes(currentHotel) &&
        document.getElementById("hideMoreThan2") == null
      ) {
        var sheet2 = document.createElement("style");
        sheet2.setAttribute("id", "hideMoreThan2");
        sheet2.innerHTML = ".hide-more-than-2 {display:none!important;}";
        document.getElementById("bookingFormContainer").appendChild(sheet2);
      } else {
        if (
          document.getElementById("hideMoreThan2") &&
          !hideMoreThan2.includes(currentHotel)
        ) {
          document.getElementById("hideMoreThan2").remove();
        }
      }
      if (
        hideMoreThan3.includes(currentHotel) &&
        document.getElementById("hideMoreThan3") == null
      ) {
        var sheet3 = document.createElement("style");
        sheet3.setAttribute("id", "hideMoreThan3");
        sheet3.innerHTML = ".hide-more-than-3 {display:none!important;}";
        document.getElementById("bookingFormContainer").appendChild(sheet3);
      } else {
        if (
          document.getElementById("hideMoreThan3") &&
          !hideMoreThan3.includes(currentHotel)
        ) {
          document.getElementById("hideMoreThan3").remove();
        }
      }

      window.dataLayer.quickBooking.hotelValue = currentHotel;
      window.dataLayer.quickBooking.hotelName = document.querySelector(
        "option[value='" + currentHotel + "']"
      ).textContent;
    });

  $("#bookingFormContainer").submit(function (event) {
    window.dataLayer.quickBooking.hotelValue =
      document.getElementById("location").value;
    window.dataLayer.quickBooking.adultsSerialized = "";
    window.dataLayer.quickBooking.childrenCountSerialized = "";
    window.dataLayer.quickBooking.childrenAgeSerialized = "";

    event.preventDefault();
    // declare all field variables in the right format to use them in the different Profiles independently.
    window.dataLayer.quickBooking.language = $(
      ".navigationMain__languageSwitcher li.current-lang a"
    ).attr("lang");

    serializeRoomData();

    switch (window.dataLayer.quickBooking.language) {
      case "en_US":
      case "en_GB":
      case "en-GB":
      case "en-US":
        window.dataLayer.quickBooking.language = "en-US";
        break;
    }

    let request =
      "adult=" +
      window.dataLayer.quickBooking.adultsSerialized +
      "&arrive=" +
      window.dataLayer.quickBooking.arrive +
      "&chain=" +
      window.dataLayer.quickBooking.hotelChain +
      "&child=" +
      window.dataLayer.quickBooking.childrenCountSerialized +
      "&childages=" +
      window.dataLayer.quickBooking.childrenAgeSerialized +
      "&depart=" +
      window.dataLayer.quickBooking.depart +
      "&hotel=" +
      window.dataLayer.quickBooking.hotelValue +
      "&level=" +
      window.dataLayer.quickBooking.level +
      "&locale=" +
      window.dataLayer.quickBooking.language +
      "&rooms=" +
      window.dataLayer.quickBooking.roomCount +
      (window.dataLayer.quickBooking.coupon != ""
        ? "&promo=" + window.dataLayer.quickBooking.coupon
        : "");
    if (window.dataLayer.quickBooking.hotelValue != "default") {
      window.open(
        window.dataLayer.quickBooking.baseLink +
        request +
        window.dataLayer.quickBooking.gclid,
        "_blank"
      );
    } else {
      window.dataLayer.quickBooking.level = "chain";
      request =
        "adult=" +
        window.dataLayer.quickBooking.adultsSerialized +
        "&arrive=" +
        window.dataLayer.quickBooking.arrive +
        "&chain=" +
        window.dataLayer.quickBooking.hotelChain +
        "&child=" +
        window.dataLayer.quickBooking.childrenCountSerialized +
        "&childages=" +
        window.dataLayer.quickBooking.childrenAgeSerialized +
        "&depart=" +
        window.dataLayer.quickBooking.depart +
        "&level=" +
        window.dataLayer.quickBooking.level +
        "&locale=" +
        window.dataLayer.quickBooking.language +
        "&rooms=" +
        window.dataLayer.quickBooking.roomCount +
        (window.dataLayer.quickBooking.coupon != ""
          ? "&promo=" + window.dataLayer.quickBooking.coupon
          : "");

      window.open(
        window.dataLayer.quickBooking.defaultLink +
        request +
        window.dataLayer.quickBooking.gclid,
        "_blank"
      );
    }
    window.dataLayer.push({
      event: "quickBookingSubmit",
      data: window.dataLayer.quickBooking,
    });
  });

  function serializeRoomData() {
    let roomInputs = document.querySelectorAll(
      ".bookingForm_config--input--list__rooms--roomWrapper"
    );
    window.dataLayer.quickBooking.adultsSerialized = "";
    window.dataLayer.quickBooking.childrenCountSerialized = "";
    window.dataLayer.quickBooking.childrenAgeSerialized = "";

    for (let i = 0; i < window.dataLayer.quickBooking.roomCount; i++) {
      let adultCount = roomInputs[i].querySelector(".adults select").value;
      window.dataLayer.quickBooking.adultsSerialized += adultCount;
      if (i + 1 != window.dataLayer.quickBooking.roomCount)
        window.dataLayer.quickBooking.adultsSerialized += "|";

      let infantInputs = roomInputs[i].querySelectorAll(".infantInput");
      let infantCount = infantInputs.length;
      window.dataLayer.quickBooking.childrenCountSerialized += infantCount;

      if (i + 1 != window.dataLayer.quickBooking.roomCount)
        window.dataLayer.quickBooking.childrenCountSerialized += "|";
      if (infantCount == 0 && i + 1 != window.dataLayer.quickBooking.roomCount)
        window.dataLayer.quickBooking.childrenAgeSerialized += ",";
      else {
        for (let j = 0; j < infantCount; j++) {
          window.dataLayer.quickBooking.childrenAgeSerialized +=
            infantInputs[j].querySelector("select").value;
          if (j + 1 != infantCount)
            window.dataLayer.quickBooking.childrenAgeSerialized += "|";
          if (
            j + 1 == infantCount &&
            i + 1 != window.dataLayer.quickBooking.roomCount
          )
            window.dataLayer.quickBooking.childrenAgeSerialized += ",";
        }
      }
    }
  }

  function toggleModal(modal) {
    if (modal.classList.contains("hidden")) {
      modal.classList.remove("hidden");
    } else {
      modal.classList.add("hidden");
    }
  }

  function storeInputNode(node, name) {
    window[name] = node.cloneNode(true);
  }

  function addInfantInput(listId) {
    var infantList = document.getElementById(listId);
    var index = infantList.getAttribute("data-index");
    var infantListIndex = infantList.getAttribute("list-index");
    var input = window.infantInputClone.cloneNode(true);
    input.setAttribute("id", "infant-" + infantListIndex + "-" + index);
    input
      .querySelector(".bookingForm__config--input--list__input__infantClose")
      .addEventListener("click", function (event) {
        removeInput(event.target);
      });
    input.classList.remove("hidden");
    index++;
    infantList.setAttribute("data-index", index);

    infantList.insertBefore(input, infantList.querySelector(".addInfant"));
  }

  function addRoomInput(roomList) {
    var index = roomList.getAttribute("room-index");
    var roomInput = window.roomInputClone.cloneNode(true);
    var label = roomInput.querySelector("span");
    var closeButton = document.createElement("span");

    closeButton.classList.add("closeRoom");
    closeButton.setAttribute("room-id", "room-" + index);

    closeButton.addEventListener("click", function (event) {
      /* var list = document.querySelector('.bookingForm_config--input--list__rooms');
      var listIndex = list.getAttribute('room-index');
      list.setAttribute('room-index', listIndex - 1); */
      document.getElementById(event.target.getAttribute("room-id")).remove();
      window.dataLayer.quickBooking.roomCount--;
    });

    roomInput.setAttribute("id", "room-" + index);

    roomInput
      .querySelector("#infantList-0")
      .setAttribute("id", "infantList-" + index);

    roomInput
      .querySelector(".addInfant")
      .addEventListener("click", function (event) {
        addInfantInput("infantList-" + (index - 1));
      });
    label.appendChild(closeButton);
    roomList.insertBefore(roomInput, document.getElementById("addRoom"));
    index++;
    roomList.setAttribute("room-index", index);
  }

  function removeInput(node) {
    node.parentNode.remove();
  }

  /**
   * @param {string} id value of the selector used to choose the hotel
   * @return {type} returns false if not a franchise hotel OR returns true if franchise hotel OR returns a string id of the needed parameter mask if its a franchise that supports parameters.
   */

  function checkForFranchise(id) {
    if (id !== "0" && id.includes("http") == false && id.includes("/") == false)
      return false;
    else return true;
  }

  if (document.querySelector(".bookingForm .bookingForm__button.main")) {
    const toggles = document.querySelectorAll(".toggleBooking");
    const main = document.querySelector(
      ".bookingForm .bookingForm__button.main"
    );
    const addInfant = document.querySelectorAll(".addInfant");

    main.addEventListener("click", function (event) {
      var hotelValue = jQuery('#bookingFormContainer select[name="hotel"]')
        .children("option:selected")
        .val();
      if (checkForFranchise(hotelValue) == true) {
        var link = jQuery('#bookingFormContainer select[name="hotel"]')
          .children("option:selected")
          .val();
        window.open(link, "_blank");
      } else {
        toggleModal(document.getElementById("bookingInput"));
        toggleModal(document.getElementById("bookingWrapper"));
        window.dataLayer.push({
          event: "quickBookingNextStep",
          data: window.dataLayer.quickBooking,
        });
      }
    });

    document
      .querySelector(".toggleBooking.closeModal")
      .addEventListener("click", () => {
        serializeRoomData();
        window.dataLayer.push({
          event: "quickBookingCloseModal",
          data: window.dataLayer.quickBooking,
        });
      });

    storeInputNode(document.getElementById("infant-0-0"), "infantInputClone");
    if (document.getElementById("infant-0-0"))
      document.getElementById("infant-0-0").remove();
    storeInputNode(document.getElementById("room-0"), "roomInputClone");

    if (document.getElementById("addRoom")) {
      document
        .getElementById("addRoom")
        .addEventListener("click", function (event) {
          addRoomInput(
            document.querySelector(".bookingForm_config--input--list__rooms")
          );
          window.dataLayer.quickBooking.roomCount = document.querySelectorAll(
            ".bookingForm_config--input--list__rooms--roomWrapper"
          ).length;
        });
    }
    for (let i = 0; i < addInfant.length; i++) {
      addInfant[i].addEventListener("click", function (event) {
        addInfantInput("infantList-" + i);
      });
    }

    for (let i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener("click", function (event) {
        toggleModal(document.getElementById("bookingInput"));
        toggleModal(document.getElementById("bookingWrapper"));
      });
    }
  }

  function initUtmExtension() {
    if (window.location.search.includes("utm_")) {
      let amp = "&";
      let utm = {
        parameters: {
          utm_source: {},
          utm_medium: {},
          utm_campaign: {},
          utm_content: {},
          utm_term: {},
        },
        toString: function () {
          let result = [];
          Object.entries(this.parameters).forEach((parameterEntry) => {
            if (parameterEntry[1].value != undefined)
              result.push(parameterEntry[1].value);
          });
          return result.join("&");
        },
        findAllUtmParameters: function () {
          Object.entries(this.parameters).forEach((parameterEntry) =>
            this.findUtmParameter(parameterEntry)
          );
        },
        findUtmParameter: function (parameterEntry) {
          let [parameterName, parameter] = [
            parameterEntry[0],
            parameterEntry[1],
          ];
          parameter.start = window.location.search.indexOf(parameterName);

          parameter.end = window.location.search.indexOf(amp, parameter.start);
          parameter.end =
            parameter.end == -1 ? window.location.search.length : parameter.end;

          if (parameter.start > -1)
            parameter.value = window.location.search.slice(
              parameter.start,
              parameter.end
            );
        },
      };

      utm.findAllUtmParameters();

      let aTags = document.querySelectorAll("a");
      aTags.forEach((elem) => {
        if (
          elem.href.includes("utm_") ||
          elem.href.includes("javascript:") ||
          elem.href.includes("mailto:") ||
          elem.href.length == 0
        )
          return;
        else {
          let url, parameters;
          let hash = "";
          let paramIndex = elem.href.indexOf("?");
          let hashIndex = elem.href.indexOf("#");

          if (hashIndex > -1) {
            hash = elem.href.slice(hashIndex);
            [url, parameters] =
              paramIndex > -1
                ? [
                  elem.href.slice(0, paramIndex),
                  elem.href.slice(paramIndex, hashIndex) + amp,
                ]
                : [elem.href.slice(0, hashIndex), "?"];
          } else {
            [url, parameters] =
              paramIndex > -1
                ? [
                  elem.href.slice(0, paramIndex),
                  elem.href.slice(paramIndex) + amp,
                ]
                : [elem.href, "?"];
          }
          elem.href = url + parameters + utm.toString() + hash;
        }
      });
    }
  }
  initUtmExtension();

  //Component Accordion
  var acc = document.getElementsByClassName("accordions__title");
  var i;

  //Initiate state to close. Accordions state have to be open, if javascript is deactivated for seo relevance
  for (i = 0; i < acc.length; i++) {
    var panel = acc[i].nextElementSibling;
    panel.style.maxHeight = 0;
  }

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight != 0 + "px") {
        panel.style.maxHeight = 0;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        let parent = panel.closest(".accordions__text.parent");
        if (parent) {
          parent.style.maxHeight =
            parent.scrollHeight + panel.scrollHeight + "px";
        }
      }
    });
  }
});

if (document.getElementById("faq_main_title")) {
  var faq_title = document.getElementById("faq_main_title");
  var faq_icon = document.getElementById("faq_main_icon");
  var categories = document.querySelectorAll("[data-faq-category-wrapper]");
  var questions = document.querySelectorAll(".faq_question");
  var back_button = document.querySelector(".faq_back_button");
  var faq_section = document.querySelector(".faq_section");

  for (var i = 0; i < categories.length; i++) {
    categories[i].onclick = function () {
      if (!this.parentNode.classList.contains("open")) {
        faq_section.classList.add("open_cat");
        this.parentNode.classList.add("open");
        var childs = this.childNodes;
        faq_icon.src = childs[1].src;
        faq_title.innerText = childs[3].innerText;
      }
    };
  }
  for (var j = 0; j < questions.length; j++) {
    questions[j].onclick = function () {
      if (!this.classList.contains("open")) {
        for (var z = 0; z < questions.length; z++) {
          if (questions[z].classList.contains("open")) {
            questions[z].classList.remove("open");
          }
        }
        this.classList.add("open");
      } else if (this.classList.contains("open")) {
        this.classList.remove("open");
      }
    };
  }
  back_button.onclick = function () {
    faq_icon.src = faq_icon.getAttribute("data");
    faq_title.innerText = faq_title.getAttribute("data");
    faq_section.classList.remove("open_cat");
    for (var u = 0; u < categories.length; u++) {
      if (categories[u].parentNode.classList.contains("open")) {
        categories[u].parentNode.classList.remove("open");
      }
    }
    for (var l = 0; l < questions.length; l++) {
      if (questions[l].classList.contains("open")) {
        questions[l].classList.remove("open");
      }
    }
  };
}

if (document.getElementById("cert_button")) {
  var button = document.getElementById("cert_button");
  var logo = document.getElementById("cert_logo");
  var text = document.getElementById("cert_text");
  var infoIcon = document.getElementById("icon_info");
  var closeIcon = document.getElementById("icon_close");

  button.onclick = function () {
    if (closeIcon.classList.contains("hidden")) {
      infoIcon.classList.add("hidden");
      text.classList.remove("hidden");
      closeIcon.classList.remove("hidden");
    } else {
      infoIcon.classList.remove("hidden");
      text.classList.add("hidden");
      closeIcon.classList.add("hidden");
    }
  };
}

function sortInputs(parent, childSelector) {
  let nodeArr = [];
  let nodeList = parent.querySelectorAll(childSelector);
  nodeList.forEach((node) => {
    if (
      !node.innerHTML.includes(" Hotel auswählen") &&
      !node.innerHTML.includes(" Choose a Hotel")
    )
      nodeArr.push(node);
  });
  nodeArr.sort((a, b) => a.innerHTML.localeCompare(b.innerHTML));
  nodeArr.forEach((option) => parent.appendChild(option));
}

window.addEventListener("load", function (event) {
  if (document.getElementById("location"))
    sortInputs(document.getElementById("location"), "option");
  if (document.querySelector(".hotelsMap__navigationItems"))
    sortInputs(document.querySelector(".hotelsMap__navigationItems"), "a");
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    window.dataLayer.push({
      event: event.type,
    });
  });
});

window.addEventListener("CookiebotOnLoad", function (event) {
  let hcLocationContainer = document.getElementById(
    "HotelCareerLocationContainer"
  );

  if (hcLocationContainer) {
    if (window.Cookiebot.consent.preferences) {
      initHcJobDisplay();
    } else {
      showCookieConsentPopup(hcLocationContainer, initHcJobDisplay, false);
    }
  }

  let hcContainer = document.getElementById("HotelCareerContainer");
  if (hcContainer) {
    if (window.Cookiebot.consent.preferences) {
      hcContainer.append(createHcIframe());
    } else {
      showCookieConsentPopup(hcContainer, createHcIframe, true);
    }
  }
  initChatBotConsentListener();
  if (!window.Cookiebot.consent.preferences) {
    chatBotConsentContainer && chatBotConsentContainer.classList.add("active");
  }
});

window.addEventListener("CookiebotOnAccept", function (e) {
  if (
    window.Cookiebot.consent.preferences ||
    window.Cookiebot.consent.marketing ||
    window.Cookiebot.consent.statistics
  ) {
    //loadGTM();
  }
  if (window.Cookiebot.consent.preferences) {
    createDialogShiftScript();
    chatBotConsentContainer &&
      setTimeout(() => {
        chatBotConsentContainer.classList.remove("active");
      }, 6000);
  }
});


function createDialogShiftScript() {
  if (!document.querySelector(`head [src='${dialogShiftScriptUrl}']`)) {
    var script = document.createElement("script");
    script.src = dialogShiftScriptUrl;
    document.getElementsByTagName("head")[0].appendChild(script);
  }
}

var chatBotConsentContainer;

function initChatBotConsentListener() {
  chatBotConsentContainer = document.querySelector(
    ".chatbot-consent-container"
  );

  if (chatBotConsentContainer) {
    document
      .querySelector(".chatbot-consent-dialog-container button")
      .addEventListener("click", (event) => {
        window.Cookiebot.submitCustomConsent(true);
        chatBotConsentContainer.classList.add("confirmed");
      });
  }
}

function createHcScripts() {
  var script1 = document.createElement("script");
  script1.src =
    "https://ajax.googleapis.com/ajax/libs/jquery/1.7.0/jquery.min.js";
  var script2 = document.createElement("script");
  script2.src = hotelCareerScriptUrl;
  return [script1, script2];
}

function updateHcJobsASAP() {
  var hcJobsInterval = setInterval(function () {
    var hcJoblist = document.querySelectorAll(".hc-joblist-offer-list");
    if (hcJoblist.length > 0) {
      addHcLearnMoreButton();
      clearInterval(hcJobsInterval);
    } else {
      if (
        document.getElementById("HotelCareerLocationContainer")
          .childElementCount < 3
      ) {
        document.getElementById(
          "HotelCareerLocationContainer"
        ).parentElement.innerHTML = "";
        clearInterval(hcJobsInterval);
      }
    }
  }, 100);
}

function initHcJobDisplay() {
  document
    .getElementById("HotelCareerLocationContainer")
    .append(...createHcScripts());
  updateHcJobsASAP();
}

function addHcLearnMoreButton() {
  document.querySelectorAll(".hc-joblist-offer-link").forEach((elem) => {
    let learnMoreBtn = document.createElement("a");
    learnMoreBtn.href = elem.href;
    learnMoreBtn.target = "_blank";
    learnMoreBtn.classList.add("apply-btn", "local");
    learnMoreBtn.textContent = "zu hotelcareer.de";
    elem.parentElement.append(learnMoreBtn);
  });
}

function createHcIframe() {
  var elem = document.createElement("iframe");
  elem.width = 1000;
  elem.height = 2000;
  elem.src = hotelCareerIframeUrl;
  return elem;
}

function showCookieConsentPopup(container, callback, emptyContainer) {
  let consentButton = document.createElement("button");
  consentButton.classList.add("teaser__button");
  consentButton.textContent = "Jetzt zustimmen";
  consentButton.addEventListener("click", (e) => {
    while (
      emptyContainer &&
      container.firstChild &&
      container.removeChild(container.firstChild)
    );
    container.append(...callback());
    container.classList.remove("career-no-consent");
    window.Cookiebot.submitCustomConsent(true);
  });

  let consentHeadlineElem = document.createElement("p");
  consentHeadlineElem.classList.add("font-h4");
  consentHeadlineElem.textContent = "Zustimmung Erforderlich";

  let consentTextElem = document.createElement("p");
  consentTextElem.innerHTML =
    'Um das Karriereportal von HotelCareer nutzen zu können müssen Sie der Nutzung von "Präferenzen"-Cookies zustimmen.<br><br>Sie können Ihre Einwilligung jederzeit anpassen.';

  let consentContainer = document.createElement("div");
  consentContainer.classList.add(
    "career-consent-container",
    "teaser--reversedColors"
  );
  consentContainer.append(consentHeadlineElem, consentTextElem, consentButton);

  container.classList.add("career-no-consent");
  container.append(consentContainer);
}

window.addEventListener("load", function (event) {
  if (document.querySelectorAll(".greensign-widget-container").length > 0) {
    (function (h, o, t, e, l, g, s) {
      (h[l] =
        h[l] ||
        function () {
          (h[l].q = h[l].q || []).push(arguments);
        }),
        (h[l].l = 1 * new Date());
      (g = o.createElement(t)), (s = o.getElementsByTagName(t)[0]);
      g.async = 1;
      g.src = e;
      s.parentNode.insertBefore(g, s);
    })(window, document, "script", greensignScriptUrl, "gs");

    document.querySelectorAll("[data-gs-widget-id]").forEach(function (e) {
      let gs_widget_id = e.getAttribute("data-gs-widget-id");
      let gs_widget_lang = e.getAttribute("data-gs-widget-lang");
      if (gs_widget_id) {
        window.gs(gs_widget_id, {
          container: "#greensign-widget-" + gs_widget_id,
          lang: gs_widget_lang,
        });
      }
    });

    let updateGsWidgetInterval = setInterval(function () {
      let gsWidgets = document.querySelectorAll(
        ".gs-widget-container.gs-position-text.is-open"
      );
      if (gsWidgets.length > 0) {
        gsWidgets.forEach((elem) => {
          elem.classList.remove("is-open");
          let infoIcon = document.createElement("img");
          infoIcon.classList.add("gs-info-icon");
          infoIcon.addEventListener("click", (event) => {
            jQuery(".gs-logo").click();
          });
          elem.querySelector(".gs-logo-container").append(infoIcon);
          elem.querySelector(".gs-info-link a").href = `${greenSignUrl}${document.querySelector("html").lang == "de-DE" ? "" : "en"
            }`;
        });
        clearInterval(updateGsWidgetInterval);
      }
    }, 100);
  }
});

window.addEventListener("load", () => {
  let consentWithdrawElementObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes) {
        for (let n of mutation.addedNodes)
          if (

            n.nodeType == 1 &&
            n.querySelector("[data-consent-action='withdraw']")
          )
            n.querySelector("[data-consent-action='withdraw']").addEventListener("click", (e) => {
              window.Cookiebot.withdraw();
              window.location.reload();
            });
      }
    });
  });

  consentWithdrawElementObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });
});

window.addEventListener("CookiebotOnDialogDisplay", () => {
  if (
    document.querySelector("body.privacy-policy") &&
    window.Cookiebot.consent.stamp == 0
  ) {
    window.Cookiebot.hide();
  }
});



// WEBPACK FOOTER //
// ./scripts/necessary.js